import { useState } from "react"
import "./index.css"

import LogoImg from "../../assets/logo.png";
import { Link } from "react-router-dom";
import ReviewsModal from "../ReviewsModal"

export default function Header() {
    const [isReviewsModalOpen, setIsReviewsModalOpen] = useState(false);

    return (
        <div className="z-50 relative">
            <ReviewsModal
                isOpen={isReviewsModalOpen}
                onClose={() => setIsReviewsModalOpen(false)}
            />
            <div className="w-full bg-[#383434] py-2.5 md:py-4 flex flex-col justify-center">
                <p className="font-semibold text-[10px] md:text-[16px] text-white text-center">Click link below to contact us</p>
            </div>
            <div className="bg-[#d1b98b] py-3 px-4">
                <div className="max-w-[1440px] mx-auto flex flex-col sm:flex-row justify-between items-center gap-4">
                    <Link to="/" className="w-[120px] md:w-[150px]">
                        <img className="w-full" alt="logo" src={LogoImg} />
                    </Link>
                    <div className="flex flex-col sm:flex-row items-center gap-2">
                        <Link
                            to="/register/customer"
                            className="btn flex items-center justify-center"
                        >
                            Rent your account to us
                        </Link>
                        <button
                            onClick={() => setIsReviewsModalOpen(true)}
                            className="btn"
                        >
                            Reviews
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}